import React from 'react';
import InfoPopover from 'shared/components/andtComponents/InfoPopover/index.jsx';
import { useRootStore } from 'app/contexts/RootStoreContext.jsx';
import { useMainDashboardContext } from 'app/containers/MainDashboard/contexts/mainDashboardContext.jsx';
import { useBrand } from 'app/contexts/Brand/BrandContext.js';
import { CLOUD_TYPE_IDS } from 'users/constants/usersConstants.js';
import tooltipStyles from 'shared/components/andtComponents/Tooltip.module.scss';
import styles from 'app/containers/MainDashboard/panels/HistoryWithForecast/forecastHeader.module.scss';

const TooltipList = ({ text }) => {
  return (
    <ul className={styles.tooltipList}>
      {text.split('\n').map((line) => (
        <li key={line.trim()}>
          {line}
          <br />
        </li>
      ))}
    </ul>
  );
};

const TooltipContent = (appStore, usersStore) => {
  if (!appStore.isKeyCloakManagement) {
    return (
      <div className={styles.textWrapper}>
        <span>Forecast support:</span>
        <TooltipList text={`Cost types: Cost + Discount. \n Cost: Unblended (for AWS and FOCUS accounts)`} />
        <span className={styles.paddingTop}>Forecast does not include:</span>
        <TooltipList text={`AWS: Tax, Support, and Marketplace \n Azure: Marketplace`} />
      </div>
    );
  }

  if (usersStore.currDispUserCloudAccountType === CLOUD_TYPE_IDS.AWS) {
    return (
      <div className={styles.textWrapper}>
        <span>Forecast data is not available for:</span>
        <TooltipList text={`Cost: Distributed and Public Costs.\n Cost Type: Credits and Refunds`} />
      </div>
    );
  }
  if (usersStore.currDispUserCloudAccountType === CLOUD_TYPE_IDS.AZURE) {
    return (
      <div className={styles.textWrapper}>
        <span>Forecast data is not available for:</span>
        <TooltipList text={`Cost: List Costs.\n Cost Type: Credits and Refunds`} />
      </div>
    );
  }
  return (
    <div className={styles.textWrapper}>
      <span>Forecast data is not available for:</span>
      <TooltipList text={`Cost Type: Credits and Refunds.`} />
    </div>
  );
};

const ForecastSpecialInfo = () => {
  const { appStore, usersStore } = useRootStore();
  const brand = useBrand();
  const { isFiltersChanged, forecastEmptyStateFiltersText } = useMainDashboardContext();

  const mspCustomerMode = usersStore.isCurrentUserReseller && appStore.isCustomerPricingMode;
  const boldForecastInfo = !appStore.isKeyCloakManagement && (mspCustomerMode || isFiltersChanged);

  return (
    <InfoPopover
      mode="outline"
      className={{
        icon: boldForecastInfo ? styles.boldInfoIcon : styles.infoIcon,
        tooltip: tooltipStyles.whiteTooltip,
        arrow: tooltipStyles.whiteArrow,
      }}
    >
      <span className={styles.tooltip}>
        {forecastEmptyStateFiltersText && TooltipContent(appStore, usersStore)}
        <div>
          <a href={brand.externalLinks.ForecastArchitecture} className={styles.navigateText}>
            Learn more
          </a>{' '}
          about {brand.name}&apos;s forecasting
        </div>
      </span>
    </InfoPopover>
  );
};

export default ForecastSpecialInfo;
